import type { Installation, Location } from "@sitescene/types";

import { apiClient } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";

export interface EdgeProvisioningAuthorizationResponse {
	authorizationGeneration: number;
	expiresAt: string;
	installationId: string;
	token: string;
}

// Mutations use promises rather than the query/mutation cache: the one-time
// token belongs only to the mounted controls for the selected organization.
export async function authorizeEdgeProvisioning(
	installationId: string,
	body: { expectedGeneration: number; intent: "authorize" | "reauthorize" },
	orgCode: string,
): Promise<EdgeProvisioningAuthorizationResponse> {
	const response = await apiClient.post<EdgeProvisioningAuthorizationResponse>(
		ENDPOINTS.shadow.installations.provisioningAuthorization(installationId),
		body,
		{ headers: { "X-Shadow-Org": orgCode } },
	);
	return response.data;
}

export async function createInstallation(
	body: { externalId: string; location: string },
	orgCode: string,
) {
	const response = await apiClient.post<Installation>(
		ENDPOINTS.shadow.installations.create,
		body,
		{
			headers: { "X-Shadow-Org": orgCode },
		},
	);
	return response.data;
}

export async function listLocations(orgCode: string, after?: string) {
	return apiClient.get<Location[]>(ENDPOINTS.shadow.locations.list, {
		headers: { "X-Shadow-Org": orgCode },
		params: after ? { after } : undefined,
	});
}

export async function revokeEdgeProvisioning(
	installationId: string,
	expectedGeneration: number,
	orgCode: string,
) {
	return apiClient.post(
		ENDPOINTS.shadow.installations.provisioningRevocation(installationId),
		{ expectedGeneration },
		{ headers: { "X-Shadow-Org": orgCode } },
	);
}
